"use client";

import React from "react";
import { Stack } from "@mui/material";
import { ColletteButton } from "@collette-travel/collette-common-controls";

interface YearSelectorProps {
  years: number[];
  selectedYear: number;
  onYearChange: (year: number) => void;
}

const YearSelector = ({ years, selectedYear, onYearChange }: YearSelectorProps) => {
  if (!years || years.length === 0) {
    return null;
  }

  return (
    <Stack
      direction="row"
      sx={{
        display: "flex",
        gap: "1.2rem",
        alignItems: "center",
        justifyContent: "center"
      }}
      data-testid="year-selector"
    >
      {years.map((year) => {
        const isSelected = year === selectedYear;

        return (
          <ColletteButton
            key={year}
            onClick={() => onYearChange(year)}
            testId={`year-button-${year}`}
            color="primary"
            variant={isSelected ? "contained" : "outlined"}
            label={year.toString()}
            sx={{
              "& span": {
                fontSize: "1.6rem!important"
              }
            }}
          />
        );
      })}
    </Stack>
  );
};

export default YearSelector;
